import { Injectable, OnInit, trigger, state, style, animate, keyframes, transition } from '@angular/core';

const /** @type {?} */ DURATION = 500;
/**
 * <p>Service wrapper for A2 animation using animate.css styles from https://github.com/daneden/animate.css.</p>
 */
export class CfAnimationService implements OnInit {
/**
 * @return {?}
 */
static bounceIn(): any {
    return trigger('bounceIn', [
      transition(':enter', [
        animate(DURATION, keyframes([
          style({
            'opacity': 0,
            '-webkit-transform': 'scale3d(.3, .3, .3)',
            'transform': 'scale3d(.3, .3, .3)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          }),
          style({
            '-webkit-transform': 'scale3d(1.1, 1.1, 1.1)',
            'transform': 'scale3d(1.1, 1.1, 1.1)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          }),
          style({
            '-webkit-transform': 'scale3d(.9, .9, .9)',
            'transform': 'scale3d(.9, .9, .9)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          }),
          style({
            'opacity': 1,
            '-webkit-transform': 'scale3d(1.03, 1.03, 1.03)',
            'transform': 'scale3d(1.03, 1.03, 1.03)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          }),
          style({
            '-webkit-transform': 'scale3d(.97, .97, .97)',
            'transform': 'scale3d(.97, .97, .97)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          }),
          style({
            'opacity': 1,
            '-webkit-transform': 'scale3d(1, 1, 1)',
            'transform': 'scale3d(1, 1, 1)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static bounceOut(): any {
    return trigger('bounceOut', [
      transition(':leave', [
        animate(DURATION, keyframes([
          style({
            '-webkit-transform': 'scale3d(.9, .9, .9)',
            'transform': 'scale3d(.9, .9, .9)'
          }),
          style({
            'opacity': 1,
            '-webkit-transform': 'scale3d(1.1, 1.1, 1.1)',
            'transform': 'scale3d(1.1, 1.1, 1.1)'
          }),
          style({
            'opacity': 0,
            '-webkit-transform': 'scale3d(.3, .3, .3)',
            'transform': 'scale3d(.3, .3, .3)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static bounceInLeft(): any {
    return trigger('bounceInLeft', [
      transition(':enter', [
        animate(DURATION, keyframes([
          style({
            'opacity': 0,
            '-webkit-transform': 'translate3d(-3000px, 0, 0)',
            'transform': 'translate3d(-3000px, 0, 0)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          }),
          style({
            'opacity': 1,
            '-webkit-transform': 'translate3d(25px, 0, 0)',
            'transform': 'translate3d(25px, 0, 0)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          }),
          style({
            '-webkit-transform': 'translate3d(-10px, 0, 0)',
            'transform': 'translate3d(-10px, 0, 0)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          }),
          style({
            '-webkit-transform': 'translate3d(5px, 0, 0)',
            'transform': 'translate3d(5px, 0, 0)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          }),
          style({
            '-webkit-transform': 'none',
            'transform': 'none',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static bounceInRight(): any {
    return trigger('bounceInRight', [
      transition(':enter', [
        animate(DURATION, keyframes([
          style({
            'opacity': 0,
            '-webkit-transform': 'translate3d(3000px, 0, 0)',
            'transform': 'translate3d(3000px, 0, 0)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          }),
          style({
            'opacity': 1,
            '-webkit-transform': 'translate3d(-25px, 0, 0)',
            'transform': 'translate3d(-25px, 0, 0)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          }),
          style({
            '-webkit-transform': 'translate3d(10px, 0, 0)',
            'transform': 'translate3d(10px, 0, 0)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          }),
          style({
            '-webkit-transform': 'translate3d(-5px, 0, 0)',
            'transform': 'translate3d(-5px, 0, 0)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          }),
          style({
            '-webkit-transform': 'none',
            'transform': 'none',
            '-webkit-animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static bounceOutLeft(): any {
    return trigger('bounceOutLeft', [
      transition(':leave', [
        animate(DURATION, keyframes([
          style({
            'opacity': 1,
            '-webkit-transform': 'translate3d(20px, 0, 0)',
            'transform': 'translate3d(20px, 0, 0)'
          }),
          style({
            'opacity': 0,
            '-webkit-transform': 'translate3d(-2000px, 0, 0)',
            'transform': 'translate3d(-2000px, 0, 0)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static bounceOutRight(): any {
    return trigger('bounceOutRight', [
      transition(':leave', [
        animate(DURATION, keyframes([
          style({
            'opacity': 1,
            '-webkit-transform': 'translate3d(-20px, 0, 0)',
            'transform': 'translate3d(-20px, 0, 0)'
          }),
          style({
            'opacity': 0,
            '-webkit-transform': 'translate3d(2000px, 0, 0',
            'transform': 'translate3d(2000px, 0, 0'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static fadeIn(): any {
    return trigger('fadeIn', [
      transition(':enter', [
        animate(DURATION, keyframes([
          style({
            'opacity': 0
          }),
          style({
            'opacity': 1
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static fadeOut(): any {
    return trigger('fadeOut', [
      transition(':leave', [
        animate(DURATION, keyframes([
          style({
            'opacity': 1
          }),
          style({
            'opacity': 0
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static fadeInLeft(): any {
    return trigger('fadeInLeft', [
      transition(':enter', [
        animate(DURATION, keyframes([
          style({
            'opacity': 0,
            '-webkit-transform': 'translate3d(-100%, 0, 0)',
            'transform': 'translate3d(-100%, 0, 0)'
          }),
          style({
            'opacity': 1,
            '-webkit-transform': 'none',
            'transform': 'none'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static fadeInRight(): any {
    return trigger('fadeInRight', [
      transition(':enter', [
        animate(DURATION, keyframes([
          style({
            'opacity': 0,
            '-webkit-transform': 'translate3d(100%, 0, 0)',
            'transform': 'translate3d(100%, 0, 0)'
          }),
          style({
            'opacity': 1,
            '-webkit-transform': 'none',
            'transform': 'none'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static fadeOutLeft(): any {
    return trigger('fadeOutLeft', [
      transition(':leave', [
        animate(DURATION, keyframes([
          style({
            'opacity': 1
          }),
          style({
            'opacity': 1,
            '-webkit-transform': 'translate3d(-100%, 0, 0)',
            'transform': 'translate3d(-100%, 0, 0)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static fadeOutRight(): any {
    return trigger('fadeOutRight', [
      transition(':leave', [
        animate(DURATION, keyframes([
          style({
            'opacity': 1
          }),
          style({
            'opacity': 1,
            '-webkit-transform': 'translate3d(100%, 0, 0)',
            'transform': 'translate3d(100%, 0, 0)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static rotateIn(): any {
    return trigger('rotateIn', [
      transition(':enter', [
        animate(DURATION, keyframes([
          style({
            'opacity': 0,
            '-webkit-transform-origin': 'center',
            'transform-origin': 'center',
            '-webkit-transform': 'rotate3d(0, 0, 1, -200deg)',
            'transform': 'rotate3d(0, 0, 1, -200deg)'
          }),
          style({
            'opacity': 1,
            '-webkit-transform-origin': 'center',
            'transform-origin': 'center',
            '-webkit-transform': 'none',
            'transform': 'none'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static rotateOut(): any {
    return trigger('rotateOut', [
      transition(':leave', [
        animate(DURATION, keyframes([
          style({
            'opacity': 1,
            '-webkit-transform-origin': 'center',
            'transform-origin': 'center'
          }),
          style({
            'opacity': 0,
            '-webkit-transform-origin': 'center',
            'transform-origin': 'center',
            '-webkit-transform': 'rotate3d(0, 0, 1, 200deg)',
            'transform': 'rotate3d(0, 0, 1, 200deg)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static rotateInDownLeft(): any {
    return trigger('rotateInDownLeft', [
      transition(':enter', [
        animate(DURATION, keyframes([
          style({
            'opacity': 0,
            '-webkit-transform-origin': 'left bottom',
            'transform-origin': 'left bottom',
            '-webkit-transform': 'rotate3d(0, 0, 1, -45deg)',
            'transform': 'rotate3d(0, 0, 1, -45deg)'
          }),
          style({
            'opacity': 1,
            '-webkit-transform-origin': 'left bottom',
            'transform-origin': 'left bottom',
            '-webkit-transform': 'none',
            'transform': 'none'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static rotateInDownRight(): any {
    return trigger('rotateInDownRight', [
      transition(':enter', [
        animate(DURATION, keyframes([
          style({
            'opacity': 0,
            '-webkit-transform-origin': 'right bottom',
            'transform-origin': 'right bottom',
            '-webkit-transform': 'rotate3d(0, 0, 1, 45deg)',
            'transform': 'rotate3d(0, 0, 1, 45deg)'
          }),
          style({
            'opacity': 1,
            '-webkit-transform-origin': 'right bottom',
            'transform-origin': 'right bottom',
            '-webkit-transform': 'none',
            'transform': 'none'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static rotateOutDownLeft(): any {
    return trigger('rotateOutDownLeft', [
      transition(':leave', [
        animate(DURATION, keyframes([
          style({
            'opacity': 1,
            '-webkit-transform-origin': 'left bottom',
            'transform-origin': 'left bottom',
          }),
          style({
            'opacity': 0,
            '-webkit-transform-origin': 'left bottom',
            'transform-origin': 'left bottom',
            '-webkit-transform': 'rotate3d(0, 0, 1, 45deg)',
            'transform': 'rotate3d(0, 0, 1, 45deg)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static rotateOutDownRight(): any {
    return trigger('rotateOutDownRight', [
      transition(':leave', [
        animate(DURATION, keyframes([
          style({
            'opacity': 1,
            '-webkit-transform-origin': 'right bottom',
            'transform-origin': 'right bottom',
          }),
          style({
            'opacity': 0,
            '-webkit-transform-origin': 'right bottom',
            'transform-origin': 'right bottom',
            '-webkit-transform': 'rotate3d(0, 0, 1, -45deg)',
            'transform': 'rotate3d(0, 0, 1, -45deg)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static slideInLeft(): any {
    return trigger('slideInLeft', [
      transition(':enter', [
        animate(DURATION, keyframes([
          style({
            'visibility': 'visible',
            '-webkit-transform': 'translate3d(-100%, 0, 0)',
            'transform': 'translate3d(-100%, 0, 0)'
          }),
          style({
            '-webkit-transform': 'translate3d(0, 0, 0)',
            'transform': 'translate3d(0, 0, 0)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static slideInRight(): any {
    return trigger('slideInRight', [
      transition(':enter', [
        animate(DURATION, keyframes([
          style({
            'visibility': 'visible',
            '-webkit-transform': 'translate3d(100%, 0, 0)',
            'transform': 'translate3d(100%, 0, 0)'
          }),
          style({
            '-webkit-transform': 'translate3d(0, 0, 0)',
            'transform': 'translate3d(0, 0, 0)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static slideOutLeft(): any {
    return trigger('slideOutLeft', [
      transition(':leave', [
        animate(DURATION, keyframes([
          style({
            '-webkit-transform': 'translate3d(0, 0, 0)',
            'transform': 'translate3d(0, 0, 0)'
          }),
          style({
            'visibility': 'hidden',
            '-webkit-transform': 'translate3d(-100%, 0, 0)',
            'transform': 'translate3d(-100%, 0, 0)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static slideOutRight(): any {
    return trigger('slideOutRight', [
      transition(':leave', [
        animate(DURATION, keyframes([
          style({
            '-webkit-transform': 'translate3d(0, 0, 0)',
            'transform': 'translate3d(0, 0, 0)'
          }),
          style({
            'visibility': 'hidden',
            '-webkit-transform': 'translate3d(100%, 0, 0)',
            'transform': 'translate3d(100%, 0, 0)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static zoomIn(): any {
    return trigger('zoomIn', [
      transition(':enter', [
        animate(DURATION, keyframes([
          style({
            'opacity': 0,
            '-webkit-transform': 'scale3d(.3, .3, .3)',
            'transform': 'scale3d(.3, .3, .3)'
          }),
          style({
            'opacity': 1
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static zoomOut(): any {
    return trigger('zoomOut', [
      transition(':leave', [
        animate(DURATION, keyframes([
          style({
            'opacity': 1
          }),
          style({
            'opacity': 0,
            '-webkit-transform': 'scale3d(.3, .3, .3)',
            'transform': 'scale3d(.3, .3, .3)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static zoomInLeft(): any {
    return trigger('zoomInLeft', [
      transition(':enter', [
        animate(DURATION, keyframes([
          style({
            'opacity': 0,
            '-webkit-transform': 'scale3d(.1, .1, .1) translate3d(-1000px, 0, 0)',
            'transform': 'scale3d(.1, .1, .1) translate3d(-1000px, 0, 0)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.550, 0.055, 0.675, 0.190)',
            'animation-timing-function': 'cubic-bezier(0.550, 0.055, 0.675, 0.190)'
          }),
          style({
            'opacity': 1,
            '-webkit-transform': 'scale3d(.475, .475, .475) translate3d(10px, 0, 0)',
            'transform': 'scale3d(.475, .475, .475) translate3d(10px, 0, 0)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.175, 0.885, 0.320, 1)',
            'animation-timing-function': 'cubic-bezier(0.175, 0.885, 0.320, 1)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static zoomInRight(): any {
    return trigger('zoomInRight', [
      transition(':enter', [
        animate(DURATION, keyframes([
          style({
            'opacity': 0,
            '-webkit-transform': 'scale3d(.1, .1, .1) translate3d(1000px, 0, 0)',
            'transform': 'scale3d(.1, .1, .1) translate3d(1000px, 0, 0)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.550, 0.055, 0.675, 0.190)',
            'animation-timing-function': 'cubic-bezier(0.550, 0.055, 0.675, 0.190)'
          }),
          style({
            'opacity': 1,
            '-webkit-transform': 'scale3d(.475, .475, .475) translate3d(-10px, 0, 0)',
            'transform': 'scale3d(.475, .475, .475) translate3d(-10px, 0, 0)',
            '-webkit-animation-timing-function': 'cubic-bezier(0.175, 0.885, 0.320, 1)',
            'animation-timing-function': 'cubic-bezier(0.175, 0.885, 0.320, 1)'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static zoomOutLeft(): any {
    return trigger('zoomOutLeft', [
      transition(':leave', [
        animate(DURATION, keyframes([
          style({
            'opacity': 1,
            '-webkit-transform': 'scale3d(.475, .475, .475) translate3d(42px, 0, 0)',
            'transform': 'scale3d(.475, .475, .475) translate3d(42px, 0, 0)'
          }),
          style({
            'opacity': 0,
            '-webkit-transform': 'scale(.1) translate3d(-2000px, 0, 0)',
            'transform': 'scale(.1) translate3d(-2000px, 0, 0)',
            '-webkit-transform-origin': 'left center',
            'transform-origin': 'left center'
          })
        ]))
      ])
    ]);
  }
/**
 * @return {?}
 */
static zoomOutRight(): any {
    return trigger('zoomOutRight', [
      transition(':leave', [
        animate(DURATION, keyframes([
          style({
            'opacity': 1,
            '-webkit-transform': 'scale3d(.475, .475, .475) translate3d(-42px, 0, 0)',
            'transform': 'scale3d(.475, .475, .475) translate3d(-42px, 0, 0)'
          }),
          style({
            'opacity': 0,
            '-webkit-transform': 'scale(.1) translate3d(2000px, 0, 0)',
            'transform': 'scale(.1) translate3d(2000px, 0, 0)',
            '-webkit-transform-origin': 'right center',
            'transform-origin': 'right center'
          })
        ]))
      ])
    ]);
  }
constructor() { }
/**
 * @return {?}
 */
ngOnInit() { }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfAnimationService_tsickle_Closure_declarations() {
/** @type {?} */
CfAnimationService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfAnimationService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
